import DisadvantageIcon from './DisadvantageIcon';

export default DisadvantageIcon;
export { DisadvantageIcon };
